import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { FieldPropsDTO } from '../../types';
import * as S from './styles';

export function Field({ label, value }: Readonly<FieldPropsDTO>): JSX.Element {
	return (
		<Col span={24}>
			<S.Label>{I18n.get(label)}:</S.Label>
			<S.Value>{value ? value : 'N/A'}</S.Value>
		</Col>
	);
}
